<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  button:disabled {
    cursor: no-drop;
  }
</style>

<template>
    <CCard>
        <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
        Log Keanggotaan
        </CCardHeader>

        <CCardBody>
            <CRow>
                <div class="col-sm-6 col-xl-16">
                    <div class="form-group">
                        <label for="" class="font-weight-bold">Pilih Tipe Data</label>
                        <select class="form-control" v-model="searchType">
                            <option 
                            v-for="(item,idx) in dataType" 
                            v-bind:key="idx" 
                            :value="item.value">{{item.label}}</option>
                        </select>
                    </div>
                </div>
            </CRow>
            <CRow>
              <CCol xl="12">
               <div class="form-group float-left">
                        <label for="" class="font-weight-bold">Data Perhalaman</label>
                        <select class="form-control" v-model="pageSize">
                            <option 
                            v-for="(item,idx) in {10:'10', 25:'25', 100:'100', 5000:'Semua Data'}" 
                            v-bind:key="idx" 
                            :value="idx">{{item}}</option>
                        </select>
                    </div>
                <div class="form-group float-right">
                        <label for="" class="font-weight-bold">Pencarian</label>
                        <input
                        class="form-control"
                        v-model="searchDataPesertaSertifikasi"
                        >
                        
                    </div>
                <br />
              </CCol>
            </CRow>
            <Crow>

            <ul
                class="nav nav-tabs bg-active border-0 border-bottom-0"
                id="myTab"
                role="tablist"
            >
                <li class="nav-item" ref="tabInputted">
                <div
                    :class="tab_selected.aria_selected_inputted ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
                    id="home-tab"
                    data-toggle="tab"
                    href="#home"
                    style="cursor: pointer"
                    role="tab"
                    aria-controls="home"
                    @click="tabChange('inputted')"
                    :aria-selected="tab_selected.aria_selected_inputted">
                    Inputted
                    <span class="badge badge-danger text-white">{{ badges.totalInputted }}</span>
                </div>
                </li>
                <li class="nav-item">
                <div
                    :class="tab_selected.aria_selected_confirmed ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white'"
                    id="profile"
                    data-toggle="tab"
                    href="#profile"
                    style="cursor: pointer"
                    role="tab"
                    aria-controls="profile"
                    @click="tabChange('confirmed')"
                    :aria-selected="tab_selected.aria_selected_confirmed">
                    Confirmed
                    <span class="badge badge-success text-white">{{
                    badges.totalConfirmed
                    }}</span>
                </div>
                </li>

            </ul>
            </Crow>
            <CDataTable class="table-responsive" 
            style="widht:100% !important" 
            :items="items" 
            :fields="fields" 
            hover sorter>
             <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #datLogAggName="{item}">
              <td class="py-2">
                {{ item.datLogAggName }}
              </td>
            </template>

            <template #datLogAggType="{item}">
              <td class="py-2" v-if="item.datLogAggType == 1">
                Data Diri
              </td>
              <td class="py-2" v-else-if="item.datLogAggType == 2">
                Data Anggota
              </td>
              <td class="py-2" v-else>
                Data Dokumen Pendukung
              </td>

            </template>

            <template #recEditor="{item}">
              <td class="py-2">
                {{item.recEditor}}
              </td>
            </template>

            <template #aksi="{item}">
              <td class="py-2 text-center">
               
                <CButton color="info" square size="sm" @click="showModal(item.id)">
                  <font-awesome-icon icon="eye" />
                </CButton>
              </td>
            </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
            
          <div class="row">
          <div class="col-6 text-left d-flex align-items-center">
            <div class="font-weight-bold ml-4">{{items.length}} Result Found</div>
          </div>
        </div>

        <CModal
        title="Modal title"
        :show.sync="modalDetailLogPeserta"
        :no-close-on-backdrop="true"
        :centered="true"
        size="xl"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12" className="py-3">
              <label for="" class="font-weight-bold">Nama Anggota</label>
              <input
                class="form-control"
                placeholder="Masukkan Nama Kategori"
                v-model="formModal.namaAnggota"
              />        
               <label for="" class="font-weight-bold">Jenis Perubahan</label>
              <input
                class="form-control"
                placeholder="Masukkan Nama Kategori"
                v-model="formModal.jenisPerubahan"
              />        
              <label for="" class="font-weight-bold">Sumber</label>
              <input
                class="form-control"
                placeholder="Masukkan Nama Kategori"
                v-model="formModal.sumber"
              />    
              <label for="" class="font-weight-bold">Keterangan</label>
              <input
                class="form-control"
                placeholder="Tambahkan Catatan"
                v-model="formModal.notes"
              />    
              <label for="" class="font-weight-bold">Histori Perubahan</label>
               <CCardBody>
                 <section v-for="(val,idx) in formModal.logPerubahan" v-bind:key="idx">
                    
                    <section v-if="Number.isInteger(idx)">{{++idx}} {{val}}</section>
                    <section v-else>{{idx}} - {{val}}</section>
                  </section>
              </CCardBody>
            </CCol>                  
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail </h6>
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success" v-if="confirmStatus == 1">Konfirmasi</CButton>
          <CButton color="readonly" v-else>Sudah Dikonfirmasi</CButton>

        </template>
      </CModal>
        
        </CCardBody>
    </CCard>
</template>

<script>
import LogKeanggotaanService from '../../services/logactivity/log-keanggotaan.service'
import { Pagination } from '../../mixins/Pagination'

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "datLogAggName",
    label: "Nama Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "emailAgg",
    label: "Email",
    sorter: true, 
    filter: false
  },
  {
    key: "datLogAggType",
    label: "Jenis Perubahan",
    sorter: true,
    filter: false,
  },
  {
    key: "recEditor",
    label: "Updated By",
    sorter: true,
    filter: false,
  },
  {
    key: "createdAt",
    label: "Created At",
    sorter: true,
    filter: false,
  },
  {
    key: "updatedAt",
    label: "Updated At",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
    data() {
        return {
            fields,
            items: [],
            tab_selected: {
                aria_selected_inputted: true,
                aria_selected_confirmed: false
            },
            badges: {
                totalInputted: 0,
                totalConfirmed: 0,
            },
            dataType : [],
            searchDataPesertaSertifikasi: '',
            searchType: 0,
            pageSize: 10,
            statusLog: 1,
            modalDetailLogPeserta: false,
            currentPage: 0,
            page:0,
            formData: '',
            indexed: 0,
            pagination: {
              totalPages: 0
            },
            formModal: {
              id:'',
              namaAnggota: '',
              jenisPerubahan: '',
              sumber: '',
              notes: '',
              logPerubahan: []
            },
            confirmStatus: 0,
        }
    },
    components: {
      Pagination
    },
    mounted() {
        this.getType();
        this.getData(
          0,
          this.pageSize,
          this.searchDataPesertaSertifikasi,
          this.searchType,
          this.statusLog,
          1);
        this.getTotalCount();
    },
    watch: {
      currentPage: function(val) {
          // alert(val-1);
          var page = val - 1;
          this.indexed = page * 10;
          // alert(this.indexed);
          this.getData(val - 1, this.pageSize, this.searchDataPesertaSertifikasi, this.type, this.statusLog,1);
          // this.getData(val-1);
        },
        searchDataPesertaSertifikasi: function (val) {
            var vm = this
            clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    var searchVar = vm.ltrim(val);
                    var searchType = vm.searchType;
                    var pageSize = vm.pageSize;
                    var statusLog = vm.statusLog;

                // console.log(searchVar+' '+searchType+" "+pageSize+" "+statusLog)
                vm.getData(vm.page, pageSize, searchVar, searchType, statusLog, vm.source) 

                  // vm.getData("0", vm.pageSize,searchVar,vm.formFilter.id_sertifikasi,vm.formFilter.status_pembayaran,vm.formFilter.periode);
                }, 1000);
        },
        searchType: function(val) {
            var vm = this
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                var searchVar = vm.ltrim(vm.searchDataPesertaSertifikasi)
                var searchType = val;
                var pageSize = vm.pageSize;
                var statusLog = vm.statusLog;

                // console.log(searchVar+' '+searchType+" "+pageSize+" "+statusLog)
                vm.getData(vm.page, pageSize, searchVar, searchType, statusLog, vm.source) 

            },1000);
        },
        pageSize: function(val) {
            var vm = this
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                var searchVar = vm.ltrim(vm.searchDataPesertaSertifikasi)
                var searchType = vm.searchType;
                var pageSize = vm.pageSize;
                var statusLog = vm.statusLog;

                // console.log(searchVar+' '+searchType+" "+pageSize+" "+statusLog)
                vm.getData(vm.page, pageSize, searchVar, searchType, statusLog, vm.source) 

            },1000);
        },
        statusLog(val) {
            var vm = this
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                var searchVar = vm.ltrim(vm.searchDataPesertaSertifikasi)
                var searchType = vm.searchType;
                var pageSize = vm.pageSize;
                var statusLog = val;

                // console.log(searchVar+' '+searchType+" "+pageSize+" "+statusLog)
                vm.getData(vm.page, pageSize, searchVar, searchType, statusLog, vm.source) 

            },1000);
        }
     },
    methods : {
        getType() {
            this.dataType = [
                {
                  value:0,
                  label:'Semua'
                },
                {
                  value:1,
                  label:'Data Diri',
                },
                {
                    value:2,
                    label:'Data Anggota'
                },
                {
                    value:3,
                    label:'Data Dokumen Pendukung'
                },
            ]    
        },
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },
        changeSizeLogAnggota(e) {
            if (e.target.value == "Semua Data") {
                this.pageSize = 50000;
            } else {
                this.pageSize = e.target.value;
            }
        },
        tabChange(value) {
            switch (value) {
                case 'inputted':
                    this.tab_selected.aria_selected_inputted = true;
                    this.tab_selected.aria_selected_confirmed = false;
                    this.statusLog = 1;
                break;
                case 'confirmed':
                    this.tab_selected.aria_selected_inputted = false;
                    this.tab_selected.aria_selected_confirmed = true;
                    this.statusLog = 2;
                break;    
            }   
        }, 
        pageChange() {
          this.getData(currentPage, this.pageSize, this.searchDataPesertaSertifikasi, this.type, this.statusLog,1);
        }, 
        getData(currentPage, pageSize, search, type, statusLog, source) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            
            LogKeanggotaanService.getLogKeanggotaan(currentPage, pageSize, search, type, statusLog, source)
                .then(response => {
                    this.items = response.data.content;
                    this.pagination.totalPages = response.data.totalPages;
                    this.currentPage = response.data.pageable.pageNumber + 1;

                    // console.log(this.items)
                    loader.hide();
                }) .catch(error => {
                  loader.hide();
                  console.log(error);
                });
        },
        closeModal() {
          this.modalDetailLogPeserta = false
        },
        showModal(value) {
          // var formData.id = value;
          // console.log(value)
          this.confirmStatus = 0;
          this.formModal.id = value;
          
          LogKeanggotaanService.confirmStatus(value).then(response => {
            console.log(response)
            this.confirmStatus = response.data.singleData.datLogAggStatus
          })
          // this.confirmStatus = 3;
          var vm = this;
          this.items.forEach(function(val,idx){
            if(val.id == value) {
              // console.log(val)
              vm.formModal.namaAnggota = val.datLogAggName;
              if(val.datLogAggType == 1) {
                vm.formModal.jenisPerubahan = 'Data Diri';
              } else if(val.datLogAggType == 2) {
                vm.formModal.jenisPerubahan = 'Data Anggota';
              } else {
                vm.formModal.jenisPerubahan = 'Data Dokumen Pendukung'
              }
            
              if(val.datLogAggSource == 1) {
                vm.formModal.sumber = 'FO User';
              } else {
                vm.formModal.sumber = 'FO Backend';
              }

              vm.formModal.notes = val.datLogAggNotes;
              vm.formModal.logPerubahan = JSON.parse(val.datLogAggOldVal)
            }
          })
          this.modalDetailLogPeserta = true;
        },
        postData() {
          console.log(this.idLogAnggota);
          var formData = {
            id:this.formModal.id,
            status:2,
            notes:this.formModal.notes
          }

          LogKeanggotaanService.putStatus(formData).then(response => {
            console.log(response)
            if(response.status == 200) {
              this.alertSuccess();
              this.closeModal();
              this.getTotalCount();
              this.getData(
                0,
                this.pageSize,
                this.searchDataPesertaSertifikasi,
                this.searchType,
                this.statusLog,
                1
              );
            }
          })
        },
        getTotalCount() {
           LogKeanggotaanService.countQuery().then(response => {
            let data = response.data;
            this.badges.totalInputted = data.anggotaInputted;
            this.badges.totalConfirmed = data.anggotaConfirmed;
          })  
        },
        alertSuccess() {
          var vm = this;

          const Toast = vm.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              toast.addEventListener("mouseenter", vm.$swal.stopTimer);
              toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: "success",
            title: "Data Berhasil Disimpan"
          });
        },

    }
}
</script>
    